module.exports = "/_next/static/images/78e38ee619f6f53ff2b504b46d4604f9-nubanker-eng@3x.jpg";